import React from "react";
import Grid from "@mui/material/Grid";
import { CustomMaterialTable } from "../../common/CustomMaterialTable";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { DialogBoxMedium } from "../../common/dialog.medium";
import FormHelperText from "@mui/material/FormHelperText";
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { CustomizedSnackbars } from '../../common/snackbars';

const AddProjectReviwer = (props) => {
  	return (
		<React.Fragment>
			<form className="form-fullwidth">
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<InputLabel id="report-label"> Report Name : {props.Reports.name}  </InputLabel>
						<input type="hidden" name="report_id" value={props.SelectedReport || ""} readOnly />
					</Grid>
					<Grid item xs={12} md={6}>
						<FormControl variant="standard" fullWidth>              
							<InputLabel id="user-label" required> Reviewer</InputLabel>
								<Select
									labelId="user-label"
									id="user_id"
									name="user_id"
									value={props.FormValues.user_id || ""}
									onChange={props.HandleOnChange}
								>
									{props.UsersList && props.UsersList.length > 0 ? (
									props.UsersList.map((user) => (
										<MenuItem key={user.user_id} value={user.user_id}>
										{user.user_fullname}
										</MenuItem>
									))
									) : (
										<MenuItem disabled>No users available</MenuItem>
									)}
								</Select>
							</FormControl>
							{(typeof props.Errors !== 'undefined') && props.Errors &&
								<FormHelperText className='error'>{props.Errors.user_id}</FormHelperText>
							}
					</Grid>
				</Grid>
			</form>
		</React.Fragment>
  	);
};

export const ReportReviewersComponent = (props) => {
  	return (
    	<>
      		<React.Fragment>
      			<div className={'listSubHeader'}>
            		<div className={'col-left'}></div>
						{props.EditPermission && 
							<div className={'action'}>
								<Tooltip title="Add Report Reviewer" aria-label="add">
									<Fab size="small" color="default" aria-label="add" className={'fab-outline'}onClick={props.AddReportReviewer}>
										<AddIcon />
									</Fab>
								</Tooltip>

							</div>
						}
        		</div>
				<div className={"mtable-basic"}>
					<CustomMaterialTable
						title=""
						columns={[
							{ title: "Report", field: "report_name" },
							{ title: "Reviewer", field: "user_fullname" }
						]}
						data={props.ReportReviewers}
						options={{
							search: false,
							actionsColumnIndex: -1,
							toolbar: true,
						}}
						components={{
							Toolbar: () => null,
						}}
						actions={[
						(rowData) => ({
								icon: "delete",
								tooltip: "Delete Report Reviewer",
								hidden:
								props.EditPermission ? false : true,
								onClick: (event, rowData) => {
								props.DeleteReportReviewer(rowData.id, rowData.report_id, rowData.user_id);
							},
						}),
						]}
					/>
				</div>
				{props.SnackbarOpen &&
					<CustomizedSnackbars
						open = {props.SnackbarOpen}
						variant= {props.SnackbarVariant}
						message = {props.SnackbarMsg}
						handleClose = {props.SnackbarClose}
					/>
				}
				<DialogBoxMedium
					Open={props.Open}
					Cancel={props.OnClose}
					ButtonName={props.Action === 'add' ?  'Save' : 'Confirm'}
					OnSubmit={props.OnConfirm}
					Title={props.Action === 'add' ? 'Add Report Reviewer':'Confirmation'}
					Disabled = {props.DisableButton}
					Content={props.Action === 'add' ? 
						<AddProjectReviwer
							UsersList = {props.UsersList}
							Reports = {props.Reports}
							SelectedReport = {props.SelectedReport}
							FormValues = {props.FormValues}
							HandleOnChange = {props.HandleOnChange}
							Errors = {props.Errors}
						/> 
						: props.ConfirmationMessage
					}
				/>
      		</React.Fragment>
    	</>
  	);
};
